import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './BabyPhotoContest.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import withLocation from "../../withLocation";
const service = new Service();

class HowItWorks extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let winnersContest = [];
        
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
            }
        }
        this.state = {
            initialData: initialData,
            metaTitle: "How to Participate in FirstCry Parenting Contest",
            metaDescription: [
                { "name": "description", "content": "Memories Contest - FirstCry Parenting" }
            ]
        }
        // alert('inside constructor');
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {    
            // alert('init'); 
        var header = {
            'Content-Type': 'application/json',
            'ftk':  ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var ConDetailUrl = reqUrl.split('/')[3];
        console.log('ConDetailUrl: ',ConDetailUrl);

        var url = global.api_url + "contest/getcontestdetails";
        let body = JSON.stringify({ 
                    "pageNo": 1,
                    "pageSize": 10 ,
                    "contestId": ConDetailUrl      
                })
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        if(navigator.onLine) {
            console.log('initialData',this.state.initialData);

            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
            } else {
                localStorage.setItem('contestDetails', JSON.stringify(this.state.initialData));
            }
        
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
            } else {
                localStorage.setItem('contestDetails', JSON.stringify(this.state.initialData));
            } 
            
            if(this.state.initialData && this.state.initialData.result && this.state.initialData.result[0].contestRule){
                var contestRule = this.state.initialData.result[0].contestRule;
                document.getElementsByClassName('howItWorks')[0].innerHTML = contestRule;
            }
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
    }

    render() {
    //    var activeContest = this.state.initialData.result;
    
        return (
            <main className="main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href="/">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href="/baby-photo-contest">Memories Contest</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>STEPS TO PARTICIPATE</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>STEPS TO PARTICIPATE</h1>
                </div>
                <div className="sub-container memoriesContest-cnt left">
                    <div className="data-container left">
                        <div className="container_bump">
                            <div className="how_it_works_steps">
                            {this.state.initialData && this.state.initialData.result && this.state.initialData.result.length > 0 ? 
                            <div className="howItWorks" id="howItWorks"></div>
                            :    
                            <div className="no_howitworks"></div>
                            }
                            </div> 
                        </div> 
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withLocation(HowItWorks);